import type { ReactElement } from "react";
import IconCalendarLeftArrow from "@/shared/components/generic/icons/IconCalendarLeftArrow.tsx";
import IconGraph from "@/shared/components/generic/icons/IconGraph.tsx";
import { LaborCostSummaryItem } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/LaborCostSummaryItem.tsx";
import { useTranslation } from "react-i18next";
import type { LaborCostChartData } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartData.ts";
import "./LaborCostSummary.scss";
import useFormatNumber from "@/shared/utils/useFormatNumber.ts";

interface Props {
  data: LaborCostChartData;
}

export default function LaborCostSummary({ data }: Props): ReactElement {
  const { t } = useTranslation("humanResources", {
    keyPrefix: "timeManagement.analysis",
  });
  const formatNumber = useFormatNumber();

  return (
    <div className="labor-cost-summary">
      <div className="labor-cost-summary-total-label">
        {t("indicators.laborCost.label")}
      </div>
      <div className="labor-cost-summary-total-value">
        {formatNumber(data.forecast, 2)} {t("indicators.laborCost.unit")}
      </div>
      <div className="labor-cost-summary-items">
        <LaborCostSummaryItem
          icon={<IconCalendarLeftArrow />}
          label={t("daySummaryMode.PREVIOUS_YEAR")}
          value={formatNumber(data.previousYear, 2)}
        />
        <LaborCostSummaryItem
          icon={<IconGraph />}
          label={t("daySummaryMode.TREND")}
          value={formatNumber(data.trend, 2)}
        />
      </div>
    </div>
  );
}
